import { Extra } from "./Extra";
import * as THREE from "three";
import { MathUtils, Vector2 } from "three";
import { zipColor, zipNormal } from "../../assets/materials";
import { ExtraType } from "../../../entities/LedExtras";
var degToRad = MathUtils.degToRad;
import "three/examples/jsm/libs/fflate.module.min";
import "../../../entities/Model";
export class ZipScreen extends Extra {
    /** Creates the zipScreen sides according to the user's choice **/
    createPanel() {
        if (this.formData.left.extra === ExtraType.ZIPSCREEN || this.formData.left.extra === ExtraType.GLASS_ZIPSCREEN || this.formData.left.extra === ExtraType.PARAPET_ZIPSCREEN) {
            // LEFT blue
            this.createZipScreen(this.dimension.left, "LEFT");
        }
        if (this.formData.right.extra === ExtraType.ZIPSCREEN || this.formData.right.extra === ExtraType.GLASS_ZIPSCREEN || this.formData.right.extra === ExtraType.PARAPET_ZIPSCREEN) {
            //RIGHT Green
            this.createZipScreen(this.dimension.right, "RIGHT");
        }
        if (this.formData.close.extra === ExtraType.ZIPSCREEN || this.formData.close.extra === ExtraType.GLASS_ZIPSCREEN || this.formData.close.extra === ExtraType.PARAPET_ZIPSCREEN) {
            // CloseSide - WHITE
            this.createZipScreen(this.dimension.close, "CLOSE");
        }
        if (this.formData.far.extra === ExtraType.ZIPSCREEN || this.formData.far.extra === ExtraType.GLASS_ZIPSCREEN || this.formData.far.extra === ExtraType.PARAPET_ZIPSCREEN) {
            // WALL Purple
            this.createZipScreen(this.dimension.far, "FAR");
        }
    }
    /** The space between 2 leg is 1 frame here. Usually 1 module means 1 frame however if the width is more than 600 or in PVC 450 and 900 there is another frame inside a module
     * We get the frame from the side object automatically
     * **/
    createZipScreen(side, name) {
        // When we have walls return
        if (this.scene.getActualSide(name).wall === true) {
            return;
        }
        let rotation = side.rotationY;
        const pos = new THREE.Vector3().copy(side.position);
        // Remove the pillar's width from the frame sizes
        const edgeWidth = this.formData.measuredModel.model.edgeWidth;
        let width = side.length - edgeWidth * 2 - edgeWidth * (side.frames - 1);
        let startingPos = pos.x - width / 2 - edgeWidth / 2 * (side.frames - 1);
        let startingPosZ = pos.z - width / 2 - edgeWidth / 2 * (side.frames - 1);
        const frameSize = width / side.frames;
        this.createFabric(rotation, pos, name, width, startingPos, startingPosZ, frameSize, side, edgeWidth);
        this.createZipPillars(rotation, pos, name, width, startingPos, startingPosZ, frameSize, side, edgeWidth);
    }
    createZipPillars(rotation, pos, name, width, startingPos, startingPosZ, frameSize, dimension, edgeWidth) {
        const side = this.scene.getActualSide(name);
        const scale = new THREE.Vector3(1, 1, 1);
        const quatRotation = new THREE.Quaternion(0, 0, 0);
        const mat = this.scene.materialPicker.getMaterial();
        mat.metalness += 0.02;
        const depth = edgeWidth / 3;
        const height = 257 - this.formData.measuredModel.model.edgeHeight / 2;
        const pillarGeom = new THREE.BoxGeometry(edgeWidth / 2, height, depth).rotateY(degToRad(rotation));
        const pillarMesh = new THREE.InstancedMesh(pillarGeom, mat, dimension.frames * 2);
        let adjustDepth = side.extra === ExtraType.GLASS_ZIPSCREEN || side.extra === ExtraType.PARAPET_ZIPSCREEN ? depth * 2 : depth;
        for (let x = 0; x <= dimension.frames * 2; x += 2) {
            let mainPos = startingPos + frameSize * x / 2 + edgeWidth * x / 2;
            let mainPosZ = startingPosZ + frameSize * x / 2 + edgeWidth * x / 2;
            if (dimension.length / dimension.frames > 500) {
                pillarMesh.setMatrixAt(dimension.frames * 2 + 1, new THREE.Matrix4().compose(pos, quatRotation, scale));
            }
            for (let i = 0; i < 2; i++) {
                let position;
                let adjust;
                if (i === 0) {
                    adjust = side.extra === ExtraType.GLASS_ZIPSCREEN || side.extra === ExtraType.PARAPET_ZIPSCREEN ? -edgeWidth / 4 : edgeWidth / 4;
                }
                else
                    adjust = side.extra === ExtraType.GLASS_ZIPSCREEN || side.extra === ExtraType.PARAPET_ZIPSCREEN ? edgeWidth / 4 : -edgeWidth / 4;
                if (this.rotated === true) {
                    if (rotation === 0) {
                        if (name === "CLOSE")
                            position = new THREE.Vector3(mainPos + adjust + frameSize * i, height / 2, pos.z + adjustDepth);
                        else
                            position = new THREE.Vector3(mainPos + adjust + frameSize * i, height / 2, pos.z - adjustDepth);
                    }
                    else {
                        if (name === "RIGHT")
                            position = new THREE.Vector3(pos.x + adjustDepth, height / 2, mainPosZ + adjust + frameSize * i);
                        else
                            position = new THREE.Vector3(pos.x - adjustDepth, height / 2, mainPosZ + adjust + frameSize * i);
                    }
                }
                else {
                    if (rotation === 0) {
                        if (name === "RIGHT")
                            position = new THREE.Vector3(mainPos + adjust + frameSize * i, height / 2, pos.z - adjustDepth);
                        else
                            position = new THREE.Vector3(mainPos + adjust + frameSize * i, height / 2, pos.z + adjustDepth);
                    }
                    else {
                        if (name === "CLOSE")
                            position = new THREE.Vector3(pos.x + adjustDepth, height / 2, mainPosZ + adjust + frameSize * i);
                        else
                            position = new THREE.Vector3(pos.x - adjustDepth, height / 2, mainPosZ + adjust + frameSize * i);
                    }
                }
                pillarMesh.setMatrixAt(x + i, new THREE.Matrix4().compose(position, quatRotation, scale));
            }
            pillarMesh.name = "zipPillar";
            this.scene.threeScene.add(pillarMesh);
        }
    }
    createFabric(rotation, pos, name, width, startingPos, startingPosZ, frameSize, dimension, edgeWidth) {
        const side = this.scene.getActualSide(name);
        const scale = new THREE.Vector3(1, 1, 1);
        const quatRotation = new THREE.Quaternion(0, 0, 0);
        // Fabric material
        const color = new THREE.Texture();
        this.scene.assignTexture(color, zipColor);
        color.repeat = new Vector2(width / 256 * 150, 160 / 256 * 150);
        const mat = new THREE.MeshStandardMaterial({
            metalness: 0.7,
            roughness: 0.5,
            map: color,
            transparent: true,
            opacity: 0.95,
        });
        const depth = edgeWidth / 3;
        let adjustDepth = side.extra === ExtraType.GLASS_ZIPSCREEN || side.extra === ExtraType.PARAPET_ZIPSCREEN ? depth * 2 : depth;
        let adjustDepthUpperEdge = side.extra === ExtraType.GLASS_ZIPSCREEN || side.extra === ExtraType.PARAPET_ZIPSCREEN ? 10 : 2.5;
        const fabricGeom = new THREE.BoxGeometry(frameSize, 130, 2).rotateY(degToRad(rotation));
        const fabricMesh = new THREE.InstancedMesh(fabricGeom, mat, dimension.frames);
        const upperEdgeMat = this.scene.materialPicker.getMaterial();
        const lowerEdgeMat = this.scene.materialPicker.getMaterial();
        upperEdgeMat.polygonOffset = true;
        upperEdgeMat.polygonOffsetFactor = -1;
        upperEdgeMat.normalMap = zipNormal;
        upperEdgeMat.metalness += 0.02;
        lowerEdgeMat.metalness += 0.02;
        const upperEdgeWidth = side.extra === ExtraType.GLASS_ZIPSCREEN || side.extra === ExtraType.PARAPET_ZIPSCREEN ? frameSize + edgeWidth : frameSize;
        const upperEdgeGeom = new THREE.BoxGeometry(upperEdgeWidth, 10, 10).rotateY(degToRad(rotation));
        const lowerEdgeWidth = side.extra === ExtraType.GLASS_ZIPSCREEN || side.extra === ExtraType.PARAPET_ZIPSCREEN ? 0 : edgeWidth;
        const lowerEdgeGeom = new THREE.BoxGeometry(frameSize - lowerEdgeWidth, 5, 4).rotateY(degToRad(rotation));
        const lowerEdgeMesh = new THREE.InstancedMesh(lowerEdgeGeom, lowerEdgeMat, dimension.frames);
        const upperEdgeMesh = new THREE.InstancedMesh(upperEdgeGeom, upperEdgeMat, dimension.frames);
        const height = 253 - this.formData.measuredModel.model.edgeHeight / 2;
        for (let x = 0; x < dimension.frames; x++) {
            let mainPos = startingPos + frameSize * x + edgeWidth * x;
            let mainPosZ = startingPosZ + frameSize * x + edgeWidth * x;
            let position;
            let position2;
            if (this.rotated === true) {
                if (rotation === 0) {
                    if (name === "CLOSE") {
                        position = new THREE.Vector3(mainPos + frameSize / 2, 180, pos.z + adjustDepth);
                        position2 = new THREE.Vector3(mainPos + frameSize / 2, 180, pos.z + adjustDepthUpperEdge);
                    }
                    else {
                        position = new THREE.Vector3(mainPos + frameSize / 2, 180, pos.z - adjustDepth);
                        position2 = new THREE.Vector3(mainPos + frameSize / 2, 180, pos.z - adjustDepthUpperEdge);
                    }
                }
                else {
                    if (name === "RIGHT") {
                        position = new THREE.Vector3(pos.x + adjustDepth, 180, mainPosZ + frameSize / 2);
                        position2 = new THREE.Vector3(pos.x + adjustDepthUpperEdge, 180, mainPosZ + frameSize / 2);
                    }
                    else {
                        position = new THREE.Vector3(pos.x - adjustDepth, 180, mainPosZ + frameSize / 2);
                        position2 = new THREE.Vector3(pos.x - adjustDepthUpperEdge, 180, mainPosZ + frameSize / 2);
                    }
                }
            }
            else {
                if (rotation === 0) {
                    if (name === "RIGHT") {
                        position = new THREE.Vector3(mainPos + frameSize / 2, 180, pos.z - adjustDepth);
                        position2 = new THREE.Vector3(mainPos + frameSize / 2, 180, pos.z - adjustDepthUpperEdge);
                    }
                    else {
                        position = new THREE.Vector3(mainPos + frameSize / 2, 180, pos.z + adjustDepth);
                        position2 = new THREE.Vector3(mainPos + frameSize / 2, 180, pos.z + adjustDepthUpperEdge);
                    }
                }
                else {
                    if (name === "CLOSE") {
                        position = new THREE.Vector3(pos.x + adjustDepth, 180, mainPosZ + frameSize / 2);
                        position2 = new THREE.Vector3(pos.x + adjustDepthUpperEdge, 180, mainPosZ + frameSize / 2);
                    }
                    else {
                        position = new THREE.Vector3(pos.x - adjustDepth, 180, mainPosZ + frameSize / 2);
                        position2 = new THREE.Vector3(pos.x - adjustDepthUpperEdge, 180, mainPosZ + frameSize / 2);
                    }
                }
            }
            upperEdgeMesh.setMatrixAt(x, new THREE.Matrix4().compose(new THREE.Vector3(position2.x, height, position2.z), quatRotation, scale));
            upperEdgeMesh.renderOrder = 1;
            lowerEdgeMesh.setMatrixAt(x, new THREE.Matrix4().compose(new THREE.Vector3(position.x, 115, position.z), quatRotation, scale));
            fabricMesh.setMatrixAt(x, new THREE.Matrix4().compose(position, quatRotation, scale));
            this.scene.threeScene.add(fabricMesh, upperEdgeMesh, lowerEdgeMesh);
        }
    }
}
